'use client'

import { useTimedCart } from '@/context/TimedCartContext'

const CartButton = () => {
  const { itemCount, openCart } = useTimedCart()

  return (
    <button
      onClick={openCart}
      className="relative p-2 text-text-secondary hover:text-text-primary rounded-lg hover:bg-surface-tertiary transition-colors"
      aria-label="Shopping cart"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
        />
      </svg>

      {itemCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 bg-primary text-text-inverse text-xs font-bold rounded-full min-w-[18px] min-h-[18px] flex items-center justify-center">
          {itemCount > 9 ? '9+' : itemCount}
        </span>
      )}
    </button>
  )
}

export default CartButton
